import 'react-toastify/dist/ReactToastify.css';

import { toast } from 'react-toastify';

import ExcluirTypes from './types'

import { MESSAGES } from '../../../../constants/messages';

const uuidv4 = require('uuid/v4');
const INITIAL_STATE = {
    filtros: {},
    protocolos: [],
    reason: [],
    total_protocolos: [],
    protocolo_excluido: null,
    msgProtocoloExcluido: false,
    msgContratoExcluido: false,
    error: false,
    loading: false,
    allSelected: false,
    buttonTitle: false,
    selecionarTodos: false,
}

const setMotivos = {
    unico: [3, 4],
    multiplo: [1, 2, 4],
    unico_multiplo: [3,1,2,4]
}

const hasComplemento = (item) => (item.tipo_codigo==="PRINCIPAL" && !!item.complemento);
const hasBloqueio = (item) => (item.situacao.codigo!=="PENDENTE");

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {

        case ExcluirTypes.SEARCH_REQUEST:
            return {
                ...state, loading: true,
                filtros: action.payload,
                selecionarTodos: false
            }

        case ExcluirTypes.SEARCH_FAILURE:
            toast.error(MESSAGES.DEFAULT_ERROR_MESSAGE)
            return { ...state, loading: false, error: true }

        case ExcluirTypes.SEARCH_SUCCESS:

            const protocolos_lista = action.payload.protocolos.map((item) => {

                const bloqueio = hasBloqueio(item);
                const complemento = bloqueio ? false : hasComplemento(item);

                return {
                    ...item,
                    isSelected: false,
                    uuid: uuidv4(),
                    complemento,
                    bloqueio,
                    disable: bloqueio || complemento ? true : false
                };
            });
            if (!protocolos_lista.length) {
                toast.error(MESSAGES.EMPTY_ERROR_MESSAGE);
            }
            return {
                ...state,
                protocolos: protocolos_lista,
                total_protocolos: action.payload.total_protocolos,
                loading: false, error: false,
                selecionarTodos: false
            }

        case ExcluirTypes.SEARCH_REASON_REQUEST:
            return { ...state, loading: true }

        case ExcluirTypes.SEARCH_REASON_FAILURE:
            return { ...state, loading: false, error: true }

        case ExcluirTypes.SEARCH_REASON_SUCCESS:
            let reason_list = [];
            let protocolos_selecionados = state.protocolos.filter((cont) => { return cont.isSelected })
            let codigo_motivos = setMotivos.unico;

            /* Contraladores das msg de exclusao */
            let msgExclusaoProtocolo = false;
            let msgExclusaoContrato = false;

            var ocurrences = protocolos_selecionados.reduce( (acc, o) => {
                acc[o.protocolo] = (acc[o.protocolo] || 0)+1;
                return acc;
              },{});

            for (const [protocolo, total] of Object.entries(ocurrences)) {
                if(total===state.protocolos[protocolo] || state.allSelected) {
                    codigo_motivos = setMotivos.unico_multiplo;
                    msgExclusaoProtocolo = true;
                } else {
                    msgExclusaoContrato = true;
                }
            }

            if(protocolos_selecionados.length===1 && state.total_protocolos[protocolos_selecionados[0].protocolo] > 1){
                codigo_motivos = setMotivos.unico
            }

            reason_list = action.payload.filter( (r) => codigo_motivos.includes(r.codigo))

            return {
                ...state,
                reason: reason_list,
                msgContratoExcluido: msgExclusaoContrato,
                msgProtocoloExcluido: msgExclusaoProtocolo,
                loading: false, error: false
            }

        case ExcluirTypes.SELECT:
            const { id: protocoloUuid } = action.payload;
            var protocolos = state.protocolos.map((item) => {
                return {
                    ...item,
                    isSelected: (item.uuid === protocoloUuid) && !item.disable ? !item.isSelected : item.isSelected,
                };
            });

            var allSelected = protocolos.every(({ isSelected })=> !!isSelected);
            var buttonTitle = allSelected;

            if(protocolos.length === 1 && state.total_protocolos[protocolos[0].protocolo] > 1){
              buttonTitle = false
            }
            return {
                ...state,
                protocolos,
                allSelected,
                selecionarTodos: allSelected,
                buttonTitle,
            };

        case ExcluirTypes.SELECT_MULTI:
            const allSelectedStatus = action.payload;

            protocolos = state.protocolos.map(item => ({
              ...item,
              isSelected: !item.disable ? allSelectedStatus : false,
            }));

            const buttonTitle_multi = protocolos.every((item) => item.isSelected);

            return {
                ...state,
                protocolos,
                allSelected: allSelectedStatus,
                selecionarTodos: protocolos.every((item) => item.isSelected),
                buttonTitle: buttonTitle_multi,
            };

        case ExcluirTypes.DELETE_REQUEST:
            return { ...state, loading: true }

        case ExcluirTypes.DELETE_FAILURE:
            toast.error(MESSAGES.DEFAULT_ERROR_MESSAGE);
            return { ...state, loading: false, error: true }

        case ExcluirTypes.DELETE_PROTOCOL_REQUEST:
            return { ...state, loading: true }

        case ExcluirTypes.DELETE_PROTOCOL_FAILURE:
            return { ...state, loading: false, error: true }

        case ExcluirTypes.CONFIRMAR_EXCLUSAO_CONTRATO:
            toast.success(action.payload.mensagem);
            return {
                ...state,
                protocolo_excluido: true,
                selecionarTodos: false,
            };

        case ExcluirTypes.CONFIRMAR_EXCLUSAO_PROTOCOLO:
            return {
                ...state,
                protocolo_excluido: true,
                selecionarTodos: false,
            };

        case ExcluirTypes.LIMPAR:

            return {
                ...state,
                INITIAL_STATE
            };

        case ExcluirTypes.CLEAR_STATUS:

            return {
                ...state,
                protocolo_excluido: null,
                selecionarTodos: false
            };

        default:
            return state;
    }
}
